import { z } from 'zod'

export const ADMINMETADATAPOST_CONTRACT_VERSION = '1.0.0' as const
export const adminMetadataPostResponseSchema = z.unknown()
export type AdminMetadataPostResponse = z.infer<typeof adminMetadataPostResponseSchema>
